export default "__VITE_ASSET__aa50cc9a__"